import { render, staticRenderFns } from "./transferManagement.vue?vue&type=template&id=a59ce404&scoped=true"
import script from "./transferManagement.vue?vue&type=script&lang=js"
export * from "./transferManagement.vue?vue&type=script&lang=js"
import style0 from "./transferManagement.vue?vue&type=style&index=0&id=a59ce404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59ce404",
  null
  
)

export default component.exports